import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'

@Injectable({
  providedIn: 'root'
})
export class ProgressService {

  constructor(private sanitized: DomSanitizer) { }

  modifier(progress: any) {
    progress.ssty = this.sanitized.bypassSecurityTrustStyle(progress.sty)
    progress.sstyp = this.sanitized.bypassSecurityTrustStyle(progress.styp)
    progress.ctyp = 'progress'
    if (progress.dis == null) progress.dis = 2
  }
}
